import { Result } from 'neverthrow';

import type { JSONValue } from '@savvy/constants/types/json-value';

/**
 * Parses a JSON string and returns the parsed value or an error
 * @param json - The JSON string to parse
 * @returns The parsed JSON value or an error
 */
export const jsonParse = Result.fromThrowable(jsonParseInner, () => 'Invalid JSON' as const);

function jsonParseInner(...args: Parameters<typeof JSON.parse>) {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- This is okay, actually makes our result safer
  return JSON.parse(...args) as JSONValue;
}
